var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Card"},[_c('div',{staticClass:"Card__Header"},[_c('h2',{staticClass:"Card__Header__Title"}),_c('div',{staticClass:"Card__Header__Buttons"},[_c('CButton',{staticClass:"mx-1",staticStyle:{"background-color":"#717b85","color":"#dcdfe3"},on:{"click":function($event){return _vm.getChartStats(1)}}},[_vm._v(" Hoy ")]),_c('CButton',{staticClass:"mx-1",staticStyle:{"background-color":"#717b85","color":"#dcdfe3"},on:{"click":function($event){return _vm.getChartStats(2)}}},[_vm._v(" Esta Semana ")]),_c('CButton',{staticClass:"mx-1",staticStyle:{"background-color":"#717b85","color":"#dcdfe3"},on:{"click":function($event){return _vm.getChartStats(3)}}},[_vm._v(" Este Mes ")]),_c('CButton',{staticClass:"mx-1",staticStyle:{"background-color":"#717b85","color":"#dcdfe3"},on:{"click":function($event){return _vm.getChartStats()}}},[_vm._v(" Todo ")])],1)]),_c('div',{staticClass:"Card__Data"},[_c('div',{staticClass:"Card__Data__Item"},[_c('p',{staticClass:"Card__Data__Item__Number"},[_vm._v(_vm._s(_vm.main_chart.complaints_total))]),_c('p',{staticClass:"Card__Data__Item__Label"},[_vm._v("Total Denuncias")])]),_c('div',{staticClass:"Card__Data__Item"},[_c('p',{staticClass:"Card__Data__Item__Number"},[_vm._v(_vm._s(_vm.main_chart.complaints_resolved))]),_c('p',{staticClass:"Card__Data__Item__Label"},[_vm._v("Denuncias Resueltas")])]),_c('div',{staticClass:"Card__Data__Item"},[_c('p',{staticClass:"Card__Data__Item__Number"},[_vm._v(_vm._s(_vm.main_chart.complaints_pending))]),_c('p',{staticClass:"Card__Data__Item__Label"},[_vm._v("En trámite")])]),_c('div',{staticClass:"Card__Data__Item"},[_c('p',{staticClass:"Card__Data__Item__Number"},[_vm._v(_vm._s(_vm.main_chart.complaints_visualized))]),_c('p',{staticClass:"Card__Data__Item__Label"},[_vm._v("Denuncias Visualizadas")])]),_c('div',{staticClass:"Card__Data__Item"},[_c('p',{staticClass:"Card__Data__Item__Number"},[_vm._v(_vm._s(_vm.main_chart.complaints_canceled))]),_c('p',{staticClass:"Card__Data__Item__Label"},[_vm._v("Denuncias Canceladas")])]),_c('div',{staticClass:"Card__Data__Item"},[_c('p',{staticClass:"Card__Data__Item__Number"},[_vm._v(_vm._s(_vm.main_chart.complaints_no_action))]),_c('p',{staticClass:"Card__Data__Item__Label"},[_vm._v("Sin actividad")])])]),_c('div',{staticClass:"Card__Chart"},[_c('CChartLine',{attrs:{"datasets":[
        {
          data: _vm.dataComplaints,
          backgroundColor: '#73A8ED',
        },
        {
          data: _vm.dataComplainResolved,
          backgroundColor: '#2B3340',
        },
      ],"options":{
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 1 | 2,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                color: 'rgba(0, 0, 0, 0)',
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                color: 'rgba(0, 0, 0, 0)',
              },
            },
          ],
        },
        scales: {
          yAxes: [
            {
              display: false,
              ticks: {
                fontColor: '#FFFFFF',
              },
            },
          ],
          xAxes: [
            {
              display: false,
              ticks: {
                fontColor: '#FFFFFF',
              },
            },
          ],
        },
      }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }